import type { ShippingAddress } from '#types/cart'

/**
 * Returns Formatted Address
 * @param address - Shipping Address
 * @returns - Formatted Address
 */
export const getFormattedAddress = (address?: ShippingAddress) => {
  if (!address) return
  let phoneNumber = ''
  const {
    firstName,
    lastName,
    addressLine1,
    addressLine2,
    city,
    postalCode,
    province,
    phone,
    altPhone,
    email,
    phoneCode,
    stateCityProvDept
  } = address

  // Getting phone number and mask
  if (phone) {
    // if we have a phone code, we need to get country code by phone code.
    // used on save billing/shipping address on checkout page
    if (phoneCode) {
      const countryCode = getCountryCodeByPhoneCode(phoneCode)
      const { phone: _phone, mask } = getPhoneWithCountryCode(phone, countryCode)
      phoneNumber = maskPhone(_phone, mask).formatted
    }
    else {
      phoneNumber = getFormattedPhoneNumber(phone)
    }
  }

  return {
    fullName: `${firstName} ${lastName}`,
    addressLine1,
    addressLine2,
    cityState: [`${city},`, province || stateCityProvDept, postalCode].filter(Boolean).join(' '),
    email,
    phone: phoneNumber,
    altPhone: altPhone ? getFormattedPhoneNumber(altPhone) : ''
  }
}
